import format from 'date-fns/format';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { useGetDataVendorQuery } from '../../../api/dataVendorApiSlice';
import { useGetDataVendorInvoiceQuery } from '../../../api/dataVendorInvoiceApiSlice';
import enGB from 'date-fns/locale/en-GB'
import fr from 'date-fns/locale/fr'
import enUS from 'date-fns/locale/en-US'
import Title from '../../../components/Title';
import Block from '../../../components/Block';
import { Button, Col } from 'react-bootstrap';
import { Icon, Loader } from '../../../components/components';
import {formatDate, formatNumber, formatPrice} from '../../../components/Format';
import DataVendorEditInvoiceModal from '../../../components/data_vendors/invoice/DataVendorInvoiceEditModal';
import {useHistoryState} from "../../../components/utils";
import ShowItem from "../../../components/ShowItem";
const locales = {'en-GB': enGB, 'fr-FR': fr, 'en-US': enUS}

const BilledCpmElt = ({element}) => {
  const { t } = useTranslation();

  return(
    <ShowItem label={`${formatNumber(element.min)} - ${formatNumber(element.max)}`} value={formatPrice(element.amount, {digits: 1})}>
      <ShowItem label={t('publisherInvoice.mau')} value={formatNumber(element.max - element.min)}/>
      <ShowItem label={t("publisherInvoice.cpm")} value={formatPrice(element.cpm, {digits: 2})}/>
    </ShowItem>)
}

const BilledCpmLines = ({billed_cpm, amount_by_range}) => {
  const { t } = useTranslation();
  if (Object.keys(billed_cpm).length == 1) {
    return <ShowItem label={t("publisherInvoice.cpm")} value={formatPrice(billed_cpm["0"], {digits: 1})}/>
  } else if (Object.keys(billed_cpm).length > 1) {
    return ( <> { amount_by_range.map((elt, i)=>( <BilledCpmElt key={i} element={elt}/> )) } </> )
  } else {
    return (<></>)
  }
}

const DataVendorInvoice = (props) => {
  const { t, i18n } = useTranslation();
  const {dataVendorKey, year, month} = useParams();
  const history = useHistory();
  const {data: dataVendor = {}} = useGetDataVendorQuery(dataVendorKey)
  const {data={}, isSuccess, isLoading} = useGetDataVendorInvoiceQuery([dataVendorKey, year, month]);
  const subTitle = t('invoice') + ' - ' + format(new Date(parseInt(year), (parseInt(month)-1), 1), 'MMMM yyyy', {locale: locales[i18n.language]})
  const onBackPath = useHistoryState(props, "onBackPath")
  const onBackTab = useHistoryState(props, "onBackTab")
  const onBack = () => {
    let pathParams = {
      pathname: onBackPath ? onBackPath : `/data_vendors/${dataVendorKey}/revenues`
    }
    if (onBackTab) {
      pathParams = {...pathParams, state: {activeTab: onBackTab}}
    }
    history.push(pathParams)
  }
  const [showEdit, setShowEdit] = useState(false)

  const unFinalizedButtons = [
    <Button onClick={()=>setShowEdit(true)}>
      <Icon icon='edit' text={t("edit")} />
    </Button>,
  ]

  const finalizedButtons = [
    <Button onClick={()=>(window.open(data.pdf_url, '_blank').focus())}>
      <Icon icon='pdf' text={t('publisherInvoice.invoicingRequest')} />
    </Button>
  ]

  return ( <>
    <Title
      main={dataVendor.name}
      sub={subTitle}
      onBack={onBack}
      children={data.final ? finalizedButtons : unFinalizedButtons}
    />
    <DataVendorEditInvoiceModal show={showEdit} setShow={setShowEdit} data={data} title={`${dataVendor.name} - ${subTitle}`}/>
    <Block style={{whiteSpace: "initial"}} title={`${t('publisherInvoice.from')} ${formatDate(data.start_date, {i18n})} ${t('publisherInvoice.to')} ${formatDate(data.end_date, {i18n})}`}>
      <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
        <ShowItem label={t('publisherInvoice.mau')} value={formatNumber(data.users)}/>
        <ShowItem label={t('publisherInvoice.mbu')} value={formatNumber(data.billed_users)}/>
        <BilledCpmLines billed_cpm={data.billed_cpm} amount_by_range={data.amount_by_range}/>
        { data.prorata_temporis != 1 && <ShowItem label={t('publisherInvoice.prorata_temporis')} value={formatNumber(data.prorata_temporis)}/> }
        <ShowItem label={t("publisherInvoice.price")} value={formatPrice(data.price, {digits: 2})}/>
        {data.billed_cpm && (Object.keys(data.billed_cpm).length > 1) && <ShowItem label={t("publisherInvoice.cpm")} value={formatPrice(data.blended_cpm, {digits: 1})}/>}
      </Loader>
    </Block>
  </> );
}

export default DataVendorInvoice;
